import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { KeycloakProvider } from '@shared/config/KeycloakConfig.tsx';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { FlexContainer, Loader, UniContextProvider } from '@uni-space/uni-components';
import React from 'react';
import routesConfig from '@app/routes/routesConfig.tsx';
import './i18n.ts';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function AppRoutes() {
  const element = useRoutes(routesConfig);

  return element;
}

createRoot(document.getElementById('root')!).render(
  <KeycloakProvider>
    <BrowserRouter>
      <UniContextProvider>
        <QueryClientProvider client={queryClient}>
          <React.Suspense
            fallback={
              <FlexContainer style={{ width: '100vw', height: '100vh' }} align="center" justify="center">
                <Loader />
              </FlexContainer>
            }
          >
            <AppRoutes />
          </React.Suspense>
        </QueryClientProvider>
      </UniContextProvider>
    </BrowserRouter>
  </KeycloakProvider>,
);
